<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content">If thou canst cuckold him,</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">Thou dost thyself a pleasure,</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">Me a sport.</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">— Iago, <i>Othello</i>, William Shakespeare</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?68ad6f97